<template>
  <div>
    <spinner class="medium spinner" />
    <md-layout
      class="bg-card"
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        class="collapsed__item"
        md-flex="15"
      >
        <div>
          <div class="field-smooth field-1" />
          <div class="field-darker field-2" />
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="35"
      >
        <div>
          <div class="field-smooth field-3" />
          <div class="field-darker field-4" />
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="15"
      >
        <div>
          <div class="field-smooth field-5" />
          <div class="field-darker field-6" />
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="15"
      >
        <div>
          <div class="field-smooth field-7" />
          <div class="field-darker field-8" />
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="20"
      >
        <div>
          <div class="field-smooth field-9" />
          <div class="field-darker field-10" />
        </div>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'

export default {
  name: 'CommonExam',
  components: {
    'spinner': Spinner
  }
}
</script>

<style lang="scss" scoped>

  .bg-card{
    border-radius: 6px;
    background-color: #ffffff;
    padding: 22px 27px 20px;
    margin: 22px 0 20px;
  }

  .field {
    &-smooth {
      height: 12px;
      opacity: 0.1;
      border-radius: 3px;
      background-color: #858585;
    }
    &-darker {
      margin-top: 10px;
      height: 14px;
      opacity: 0.1;
      border-radius: 3px;
      background-color: #111111;
    }
    &-1{
      width: 94px;
    }
    &-2{
      width: 48px;
    }
    &-3{
      width: 87px;
    }
    &-4{
      width: 128px;
    }
    &-5{
      width: 47px;
    }
    &-6{
      width: 38px;
    }
    &-7{
      width: 107px;
    }
    &-8{
      width: 78px;
    }
    &-9{
      width: 48px;
    }
    &-10{
      width: 48px;
    }
  }

  .spinner{
    position: absolute;
    left: calc(50vw - 25px);
    margin-top: 20px
  }

</style>
